import React from 'react';
import {VehicleCard} from '../../common';

export default function ProductOverviewProduct({vehicle}) {
    return <VehicleCard vehicle={vehicle} />;
}
